export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/mezzopiano-icon.svg?30179c12e1b63d18f502f45f35ecef1d";